import { queries } from "../../shared/queries";
import { useQuery } from "@rocicorp/zero/react";

export function useCurrentUserGroups() {
  const [currentUser, userResult] = useQuery(queries.currentUser());
  const [groups, groupsResult] = useQuery(queries.currentUserGroups());

  const groupIds = groups.map((g) => g.id);

  return {
    currentUser,
    groups,
    groupIds,
    loaded: userResult.type === "complete" && groupsResult.type === "complete",
  };
}
